import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityMessage = () => {
  const securityPoints = [
    {
      icon: 'Shield',
      text: 'اطلاعات پرداخت شما با استفاده از پروتکل‌های امنیتی بانکی محافظت می‌شود'
    },
    {
      icon: 'Lock',
      text: 'هویت شما به صورت کامل محرمانه باقی می‌ماند و به گیرنده افشا نمی‌شود'
    },
    {
      icon: 'Eye',
      text: 'هیچ اطلاعاتی درباره فرستنده در پیام ارسالی وجود ندارد'
    }
  ];

  return (
    <div className="space-y-3 md:space-y-4">
      <h3 className="text-base md:text-lg lg:text-xl font-bold text-gray-800 flex items-center gap-2 md:gap-3">
        <Icon
          name="ShieldCheck"
          size={20}
          color="#16a34a"
          className="md:w-6 md:h-6"
        />
        <span>امنیت و حریم خصوصی</span>
      </h3>
      <div className="space-y-3 md:space-y-4">
        {securityPoints?.map((point, index) => (
          <div key={index} className="flex items-start gap-3 md:gap-4">
            <div className="flex-shrink-0 mt-1">
              <Icon
                name={point?.icon}
                size={16}
                color="#16a34a"
                className="md:w-5 md:h-5"
              />
            </div>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              {point?.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityMessage;
